// ThankYouPopup.tsx
import * as React from 'react';
import { CSSProperties } from 'react';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../../tgccGlobal';


const modalBackdropStyle: CSSProperties = {
    position: 'fixed', // or 'absolute' if 'fixed' is not suitable for your layout
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust the opacity as needed
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1200, // Ensure it's above other content
};

const popupOverlayStyle: CSSProperties = {
    ...modalBackdropStyle, // Spread in the existing backdrop styles
    backgroundColor: 'rgba(0, 0, 0, 0.85)', // Even higher opacity for a darker effect
};

const iconStyle: CSSProperties = {
    width: '100px', // Adjust the size as needed
    height: 'auto', // Maintain aspect ratio
};


const popupContentStyle: CSSProperties = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    fontFamily: "trajan-color",
    transform: 'translate(-50%, -50%)',
    width: '80%', // Adjust width to your preference
    maxWidth: '500px', // Max width to control on larger screens
    padding: '40px', // Increased padding for better spacing
    backgroundColor: '#333', // Dark background for modal content
    color: '#fff', // White text for contrast
    borderRadius: '10px',
    marginBottom: '25px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    zIndex: 1250,
    fontSize: '11px',
    textAlign: 'center',
    display: 'flex', // Using flex to better align items
    flexDirection: 'column', // Stack items vertically
    justifyContent: 'center', // Center items vertically inside the modal
    alignItems: 'center', // Center items horizontally
};

const spanStyle: CSSProperties = {
    marginBottom: '30px',
    fontSize: '24px',
}

const baseInputStyle: CSSProperties = {
    padding: '10px 15px',
    borderRadius: '4px',
    fontFamily: "trajan-color",
    marginBottom: '10px',
    backgroundColor: 'transparent', // Transparent background
    border: '2px solid black', // Thicker, black border
    boxShadow: '5px 5px 0px rgba(0,0,0,0.75)', // Shadow for 3D effect
    color: 'white', // White text
    boxSizing: 'border-box', // Include padding in width calculation
    fontSize: '16px',
  };

const buttonStyle: CSSProperties = {
    ...baseInputStyle, // Continue using the base input styles for consistency
    padding: '10px 20px',
    backgroundColor: '#6893CC', // Maintain the bright color for visibility
    color: '#fff',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: "trajan-color",
    cursor: 'pointer',
    border: '2px solid black',
    boxShadow: 'none',
    marginTop: '10px', // Add some margin to the top for spacing
    ':hover': {
      backgroundColor: '#0056b3', // A slightly darker shade on hover
    },
    ':focus': {
      boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.5)',
    },
    '@media (max-width: 768px)': {
        padding: '12px 15px',
    },
};


export interface ThankYouPopupProps {
    isOpen: boolean;
    message: string;
    buttonText: string;
    onClose: () => void;
}

const superHeroCow = Tgcc.ResolveUrl('~/images/cow-superhero-icon.png');


const ThankYouPopup: React.StatelessComponent<ThankYouPopupProps> = ({ isOpen, message, buttonText, onClose }) => {
    if (!isOpen) return null;

    return (
        <div style={popupOverlayStyle}>
            <div style={popupContentStyle}>
                <img src={superHeroCow} alt="Superhero Cow Icon" style={iconStyle} />
                <h2 style={spanStyle}>{message}</h2>
                <button style={buttonStyle} onClick={onClose}>{buttonText}</button>
            </div>
        </div>
    );
}

export default Radium(ThankYouPopup);